import React from "react";
import { BriefcaseIcon, HomeIcon, UsersIcon, FileTextIcon, LawIcon } from "./Icons.tsx";

export const QUICK_STARTS = [
  {
    id: "employment",
    icon: <BriefcaseIcon />,
    color: "bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-500/10 dark:border-emerald-500/20",
    slugs: {
      et: "toolepingu-erakorraline-ulesutlemine-tootajalt",
      en: "extraordinary-termination-by-employee",
      ru: "chto-takoye-chrezvychaynoye-rastorzheniye-trudovogo-dogovora-rabotnikom",
    },
  },
  {
    id: "rent",
    icon: <HomeIcon />,
    color: "bg-blue-50 text-blue-600 border-blue-100 dark:bg-blue-500/10 dark:border-blue-500/20",
    slugs: {
      et: "uurnik-ei-maksa-uuri-kommunaalkulusid",
      en: "what-to-do-if-the-tenant-does-not-pay-rent-or-utilities",
      ru: "chto-delat-esli-arendator-ne-platit-arendu-ili-kommunalku",
    },
  },
  {
    id: "family",
    icon: <UsersIcon />,
    color: "bg-purple-50 text-purple-600 border-purple-100 dark:bg-purple-500/10 dark:border-purple-500/20",
    slugs: {
      et: "abikaasade-uhisvara-jagamine",
      en: "how-is-joint-property-divided-in-estonia",
      ru: "kak-delitsya-sovmestnoye-imushchestvo-suprugov-v-estonii",
    },
  },
  {
    id: "debt",
    icon: <FileTextIcon />,
    color: "bg-orange-50 text-orange-600 border-orange-100 dark:bg-orange-500/10 dark:border-orange-500/20",
    slugs: {
      et: "viivise-arvutamine-eestis",
      en: "how-to-calculate-default-interest-in-estonia",
      ru: "kak-rasschitat-penyu-v-sluchae-zadolzhennosti-v-estonii",
    },
  },
  {
    id: "company",
    icon: <LawIcon />,
    color: "bg-indigo-50 text-indigo-600 border-indigo-100 dark:bg-indigo-500/10 dark:border-indigo-500/20",
    slugs: {
      et: "kuidas-asutada-ou-eestis-elektrooniliselt",
      en: "how-to-establish-a-private-limited-company-in-estonia-electronically",
      ru: "kak-otkryt-tovarishchestvo-s-ogranichennoy-otvetstvennostyu-v-estonii-elektronno",
    },
  },
  {
    id: "alimony",
    icon: <UsersIcon />,
    color: "bg-rose-50 text-rose-600 border-rose-100 dark:bg-rose-500/10 dark:border-rose-500/20",
    slugs: {
      et: "lapse-elatisraha-arvutamine",
      en: "how-is-child-support-calculated-in-estonia",
      ru: "kak-rasschityvayutsya-alimenty-na-rebenka-v-estonii",
    },
  },
  {
    id: "redundancy",
    icon: <FileTextIcon />,
    color: "bg-amber-50 text-amber-600 border-amber-100 dark:bg-amber-500/10 dark:border-amber-500/20",
    slugs: {
      et: "tootaja-oigused-koondamisel",
      en: "employee-rights-in-case-of-redundancy",
      ru: "kakimi-pravami-obladayet-rabotnik-pri-sokrashchenii",
    },
  },
  {
    id: "sick_leave",
    icon: <BriefcaseIcon />,
    color: "bg-teal-50 text-teal-600 border-teal-100 dark:bg-teal-500/10 dark:border-teal-500/20",
    slugs: {
      et: "haiguslehe-oigused-toolepingus",
      en: "employee-rights-during-sick-and-care-leave",
      ru: "kakovy-prava-rabotnika-vo-vremya-bolnichnogo-i-lista-po-ukhodu",
    },
  },
];

export const REVOLVING_TEXT_KEYS = [
  "landing.revolving_texts.0",
  "landing.revolving_texts.1",
  "landing.revolving_texts.2",
  "landing.revolving_texts.3",
];
